import { Component, inject } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import {
  LetpensiondkBestyrelseListComponent
} from '@features/letpensiondk/letpensiondk-bestyrelse/letpensiondk-bestyrelse-list/letpensiondk-bestyrelse-list.component';
import { BestyrelseService } from '@features/letpensiondk/letpensiondk-bestyrelse/bestyrelse.service';
import {
  LetpensiondkBestyrelseDetailComponent
} from '@features/letpensiondk/letpensiondk-bestyrelse/letpensiondk-bestyrelse-detail/letpensiondk-bestyrelse-detail.component';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-letpensiondk-bestyrelse',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    LetpensiondkBestyrelseListComponent,
    LetpensiondkBestyrelseDetailComponent,
    Button
  ],
  templateUrl: './letpensiondk-bestyrelse.component.html',
  styleUrl: './letpensiondk-bestyrelse.component.css'
})
export class LetpensiondkBestyrelseComponent {
  bestyrelseService = inject(BestyrelseService);


}
